define.alias("ember-math-helpers/helpers/log-e", "settings/helpers/log-e");